var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import { CommonPlaceholders } from '../../../localization/helpers.js';
let NumberNodeInput = class NumberNodeInput extends LitElement {
    onInputChange(event) {
        const inputElement = event.target;
        this.input.value = parseFloat(inputElement.value);
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: {
                key: this.key,
                input: this.input,
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <input-number
                .value=${this.input.value}
                placeholder="${CommonPlaceholders.enterNumber()}"
                @input-number=${this.onInputChange}
            ></input-number>
        `;
    }
};
__decorate([
    property({ type: String })
], NumberNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], NumberNodeInput.prototype, "input", void 0);
NumberNodeInput = __decorate([
    localized(),
    customElement('number-node-input')
], NumberNodeInput);
export { NumberNodeInput };
//# sourceMappingURL=NumberNodeInput.js.map